import { IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { SoundsResourcePackageWrapper } from "../../common/resources/SoundsResourcePackageWrapper";
import { GameFont } from "../../common/GameFont";
import { IGameController } from "../controllers/IGameController";
import { SceneIndex } from "../../SceneIndex";
import { ButtonWithScaleAnimation } from "../../common/components/ButtonWithScaleAnimation";
import { ILatestNewsModel } from "../../common/models/latestnews/ILatestNewsModel";
import { nameof } from "../../../../shared/bindable-data";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { GameResourcePackage } from "../resources/GameResourcePackage";

export class NewsButton extends ButtonWithScaleAnimation {
    private static readonly NEWS_TEXT = 'NEWS';

    private readonly commonResources: CommonResourcesPackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly gameController: IGameController;
    private readonly latestNewsModel: ILatestNewsModel;
    private readonly logger: ILogger;

    private indicator: Sprite;
    private newsText: Text;

    public constructor(
        commonResources: CommonResourcesPackage,
        gameResources: GameResourcePackage,
        soundResources: SoundsResourcePackageWrapper,
        gameController: IGameController,
        latestNewsModel: ILatestNewsModel,
        logger: ILogger
    ) {
        super(gameResources.assets_views_game_ui_news_button_news_icon_png);
        this.commonResources = commonResources;
        this.soundResources = soundResources;
        this.gameController = gameController;
        this.latestNewsModel = latestNewsModel;
        this.logger = logger;
        this.build();
        this.latestNewsModel.propertyChanged.add(this.onLatestNewsModelPropertyChanged, this);
        this.onUp.add(this.clickHandle, this);
        this.onLatestNewsModelPropertyChanged(this.latestNewsModel, nameof(this.latestNewsModel, "latestNewsStatus"));
    }

    private async onLatestNewsModelPropertyChanged(model: ILatestNewsModel, key: string): Promise<void> {
        switch (key) {
            case nameof(model, "latestNewsStatus"):
                this.indicator.visible = model.latestNewsStatus.value?.hasUnread;
                break;
        }
    }

    private build(): void {
        this.indicator = new Sprite(this.commonResources.assets_common_ui_indicator_point_png);
        this.indicator.width = 34;
        this.indicator.height = 36;
        this.indicator.position.set(-3, 14)

        this.newsText = new Text(NewsButton.NEWS_TEXT, new NewsTextStyle());
        this.newsText.position.set(27.7, 102);

        this.addChild(this.indicator, this.newsText);
    }

    private async clickHandle(): Promise<void> {
        this.eventMode = "auto";
        try {
            this.soundResources.assets_sounds_Choose_Card_mp3.play();
            await this.gameController.showPopupBySceneIndex(SceneIndex.NEWS);

        } catch (error: unknown) {
            this.logger.error(error);
        } finally {
            this.eventMode = "static";
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.clickHandle, this);
        this.latestNewsModel.propertyChanged.remove(this.onLatestNewsModelPropertyChanged, this);
        super.destroy(options);
    }
}

class NewsTextStyle extends TextStyle {
    public constructor() {
        super({
            fill: "#253480",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32,
            stroke: 0xffffff,
            strokeThickness: 4,
            lineJoin: "round"
        });
    }
}
